export const SET_GROUP = "SET_GROUP";
export const GET_GROUP = "GET_GROUP";
export const REFRESH_GROUP = "REFRESH_GROUP"